/**
 * Constants and configuration for the BettingZone visualization
 */

// This will be overridden by theme colors in BettingZoneCanvas
export const COLORS = {
  left: {
    primary: "#f59e0b", // amber-500
    bright: "#fbbf24", // amber-400
    dark: "#d97706", // amber-600
    glow: "rgba(245, 158, 11, 0.3)",
    userPrimary: "#ffd700", // gold
    userGlow: "rgba(255, 215, 0, 0.5)",
  },
  right: {
    primary: "#a855f7", // purple-500
    bright: "#c084fc", // purple-400
    dark: "#9333ea", // purple-600
    glow: "rgba(168, 85, 247, 0.3)",
    userPrimary: "#ff00ff", // magenta
    userGlow: "rgba(255, 0, 255, 0.5)",
  },
} as const;

export const BETTING_CONFIG = {
  MIN_BET: 10,
  MAX_BET: 500,
  CLICK_THRESHOLD: 250, // Threshold for screen shake
} as const;

export const ANIMATION_CONFIG = {
  // Ghost line
  GHOST_LINE_POINTS: 40,
  GHOST_LINE_SMOOTHING_PASSES: 3,
  GHOST_LINE_MAX_BEND: 0.4, // As fraction of canvas width
  GHOST_LINE_PUSH_FORCE_MULTIPLIER: 15,

  // Particles (in milliseconds)
  PARTICLE_SPAWN_CHANCE: 0.1,
  PARTICLE_MAX_LIFE_MS: 3333, // ~200 frames at 60fps
  PARTICLE_MIN_LIFE_MS: 1667, // ~100 frames at 60fps
  PARTICLE_TEXT_MAX_LIFE_MS: 1333, // ~80 frames at 60fps
  PARTICLE_TEXT_MIN_LIFE_MS: 667, // ~40 frames at 60fps

  // Projectiles
  PROJECTILE_BASE_SIZE: 3,
  PROJECTILE_SIZE_MULTIPLIER: 5,
  PROJECTILE_BASE_SPEED: 0.04,
  PROJECTILE_SPEED_MULTIPLIER: 0.02,
  PROJECTILE_TRAIL_LENGTH: 5,

  // Effects (per millisecond rates)
  HEAT_DECAY_RATE: 0.99,
  HEAT_MIN_INTENSITY: 0.01,
  SHOCKWAVE_EXPANSION_RATE: 0.15,
  SHOCKWAVE_FADE_RATE: 0.94,
  EXPLOSION_EXPANSION_RATE: 0.2,
  EXPLOSION_FADE_RATE: 0.95,
  
  // Time-based decay rates (calculated for 60fps baseline)
  HEAT_DECAY_PER_MS: Math.pow(0.99, 60/1000), // Convert from per-frame to per-ms
  SHOCKWAVE_FADE_PER_MS: Math.pow(0.94, 60/1000),
  EXPLOSION_FADE_PER_MS: Math.pow(0.95, 60/1000),

  // Floating text (in milliseconds)
  FLOATING_TEXT_MAX_AGE_MS: 2000, // 120 frames at 60fps = 2 seconds
  FLOATING_TEXT_RISE_MULTIPLIER: 0.1,

  // Captured area
  CAPTURED_AREA_MIN_DISTORTION: 0.1,
  CAPTURED_AREA_PULSE_MIN: 0.8,
  CAPTURED_AREA_PULSE_MAX: 0.2,
  CAPTURED_AREA_PULSE_SPEED: 2,
  CAPTURED_AREA_WAVE_SPEED: 3,
  CAPTURED_AREA_WAVE_AMPLITUDE: 2,

  // Scanlines
  SCANLINE_COUNT: 7,
  SCANLINE_SPEED: 30,
  SCANLINE_HEIGHT: 36,
  SCANLINE_GRADIENT_SPREAD: 12,
} as const;

export const ZONE_CONFIG = {
  ZONE_ALPHA: 0.08,
  POWER_GRADIENT_ALPHA: 0.1,
} as const;
